import { render, staticRenderFns } from "./ComponentPlantKnowledge.vue?vue&type=template&id=38efef97&scoped=true"
import script from "./ComponentPlantKnowledge.vue?vue&type=script&lang=js"
export * from "./ComponentPlantKnowledge.vue?vue&type=script&lang=js"
import style0 from "./ComponentPlantKnowledge.vue?vue&type=style&index=0&id=38efef97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38efef97",
  null
  
)

export default component.exports